export function formatDateISO(date: Date): string {
  return date.toISOString().split('T')[0];
}

export function getLastNDaysRange(days: number, baseDate: Date = new Date()): { from: string; to: string } {
  const to = new Date(baseDate);
  const from = new Date(baseDate);
  from.setDate(baseDate.getDate() - days);
  return { from: formatDateISO(from), to: formatDateISO(to) };
}

export function getLastFiveDaysRange(baseDate: Date = new Date()): { from: string; to: string } {
  return getLastNDaysRange(5, baseDate);
}

export function getLastTenDaysRange(baseDate: Date = new Date()): { from: string; to: string } {
  return getLastNDaysRange(10, baseDate);
}

export function getLastThirtyDaysRange(baseDate: Date = new Date()): { from: string; to: string } {
  return getLastNDaysRange(30, baseDate);
}


